(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lpf-collection"] && !Shopify.designMode) return;
  try {
    
function initializeLpfCollections() {
  document.querySelectorAll('[data-lpf-collection]').forEach(root => {
    const controls = root.querySelector('[data-lpf-refine]');
    if (!controls || controls.dataset.initialized) return;
    controls.dataset.initialized = 'true';
    controls.hidden = false;
    const buttons = [...controls.querySelectorAll('[data-lpf-group]')];
    const items = [...root.querySelectorAll('[data-lpf-item]')];
    const stock = controls.querySelector('[data-lpf-stock]');
    const result = root.querySelector('[data-lpf-result]');
    let active = 'all';
    const apply = () => {
      let count = 0;
      items.forEach(item => {
        const matches = active === 'all' || item.dataset.groups.split(' ').includes(active);
        item.hidden = !(matches && (!stock.checked || item.dataset.available === 'true'));
        if (!item.hidden) count += 1;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lpfGroup === active)));
      result.textContent = result.dataset.countTemplate.replace('__COUNT__', String(count));
      root.querySelector('[data-lpf-empty]').hidden = count !== 0;
    };
    buttons.forEach(button => button.addEventListener('click', () => { active = button.dataset.lpfGroup; apply(); }));
    stock.addEventListener('change', apply);
    apply();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeLpfCollections);
else initializeLpfCollections();
document.addEventListener('shopify:section:load', initializeLpfCollections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpf-info-page"]) return;
  try {
    
function lpfInformationContents(){
 document.querySelectorAll('[data-lpf-reading]').forEach(root=>{
  if(root.dataset.enhanced)return;root.dataset.enhanced='true';
  const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);const nodes=[];let n;
  while(n=walker.nextNode()){if(/^(SECTION \d+\s*[-–]|OVERVIEW$|QUESTIONS AND CONTACT INFORMATION$)/.test(n.textContent.trim()))nodes.push(n);}
  nodes.forEach(node=>{const el=document.createElement('span');el.className='lpf-info-legal-heading';el.setAttribute('role','heading');el.setAttribute('aria-level','2');el.textContent=node.textContent;node.replaceWith(el);});
  const headings=[...root.querySelectorAll('h2,.lpf-info-legal-heading')];if(headings.length<3)return;
  const details=document.createElement('details');details.className='lpf-info-toc';const summary=document.createElement('summary');summary.textContent=root.dataset.contentsLabel;details.append(summary);const list=document.createElement('ol');
  headings.forEach((h,i)=>{if(!h.id)h.id='lpf-info-section-'+i;const li=document.createElement('li');const a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.append(a);list.append(li);});details.append(list);root.prepend(details);
 });
}
lpfInformationContents();document.addEventListener('shopify:section:load',lpfInformationContents);

  } catch(e) { console.error(e); }
})();
})();
